@if (pageReady) {
  <main class="gs-page">
    <div class="gs-page-inner">
      <app-page-header [headerData]="headerData"></app-page-header>
      <div class="notification-container">
        <app-notification [pageName]="pageName"></app-notification>
      </div>
      <div class="gs-content-container">
        <div class="left-content">
          <div class="table-header">
            <h2>Billing &amp; Payment History</h2>
            <form [formGroup]="filterGroup" class="filters">
              <mat-form-field class="filter">
                <mat-label>{{ pageLabels.activityTypeFilterLabel }}</mat-label>
                <mat-select formControlName="ActivityType">
                  @for (activity of activityTypes; track activity) {
                    <mat-option [value]="activity">{{ activity }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field class="filter">
                <mat-label>{{ pageLabels.timePeriodFilterLabel }}</mat-label>
                <mat-select formControlName="TimePeriod">
                  @for (period of timePeriods; track period) {
                    <mat-option [value]="period">{{ period.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </form>
          </div>
          <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)">
            <ng-container matColumnDef="ActivityDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by ActivityDate">
                Date
              </th>
              <td mat-cell *matCellDef="let payHist">
                {{ payHist.ActivityDate | date: "MM/dd/yyyy" | autopayHistory: payHist.AutoPayment }}
              </td>
            </ng-container>
            <ng-container matColumnDef="ActivityType">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by ActivityType">
                Type
              </th>
              <td mat-cell *matCellDef="let payHist" [innerHtml]="payHist.DisplayActivity"></td>
            </ng-container>
            <ng-container matColumnDef="ActivityAmount">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by ActivityAmount">
                Amount
              </th>
              <td mat-cell *matCellDef="let payHist">{{ payHist.ActivityAmount | currency }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
          @if (noRecordsFoundText) {
            <p>{{ noRecordsFoundText }}</p>
          }
          @if (this.billingHistoryData.length > pageLabels.itemsPerPage) {
            <mat-paginator showFirstLastButtons [pageSize]="pageLabels.itemsPerPage"></mat-paginator>
          }
        </div>
        @if (!closedAccount && !seasonalAccount) {
          <div class="right-content">
            <div class="account-section">
              <mat-card class="account-balance-card">
                <mat-card-header>
                  <mat-card-title>
                    <h2 class="h3" [innerHTML]="pageLabels.accountBalanceHeaderText"></h2>
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content class="account-section-card-content">
                  <div class="rate-plan-rate">
                    <span class="rate-price">{{ accountDetail.CurrentBalance | currency | credit }}</span>
                  </div>
                  @if (accountDetail.CurrentBalance !== undefined && 0 >= accountDetail.CurrentBalance) {
                    <p class="success-up-to-date" [innerHTML]="pageLabels.successUpToDateText"></p>
                  }
                  @if (withinFourDays) {
                    <p class="text-center" [innerHTML]="pageLabels.withinFourDaysText"></p>
                  }
                  <a
                    class="gs-link-btn"
                    color="primary"
                    routerLink="/payment"
                    [innerHTML]="pageLabels.makePaymentCtaText"
                  ></a>
                </mat-card-content>
              </mat-card>
            </div>
            <app-billing-settings [data]="billSettingsData" [accountDetail]="accountDetail"></app-billing-settings>
          </div>
        }
      </div>

      @if (seasonalAccount || closedAccount) {
        <div class="advertisement-container" [class.advertisement-container-3columns]="advertisementButtonLabel !== ''">
          <img
            class="advertisement-image"
            src="{{ advertisementLeftImage }}"
            alt="Image for {{ advertisementLeftImage }} blog"
          />
          <div class="advertisement-content" [innerHTML]="advertisementRightMessage | safe: 'SafeHtml'"></div>
          @if (headerData.RedirectURL) {
            @if (headerData.RedirectURL.includes("https://signup.gassouth.com/")) {
              <div class="cta-container">
                <button
                  role="link"
                  mat-flat-button
                  color="primary"
                  [attr.aria-label]="advertisementButtonAriaLabel"
                  (click)="redirectToWebsite()"
                  class="gs-form-button-primary ok-button"
                >
                  {{ advertisementButtonLabel }}
                </button>
              </div>
            } @else {
              <div class="cta-container">
                <button
                  role="link"
                  mat-flat-button
                  color="primary"
                  [attr.aria-label]="advertisementButtonAriaLabel"
                  (click)="redirectFromAdvertisement()"
                  class="gs-form-button-primary ok-button"
                >
                  {{ advertisementButtonLabel }}
                </button>
              </div>
            }
          }
        </div>
      }
    </div>
  </main>
}
